/** Adobe brand mark (the red "A"), used for Adobe Analytics connections. Path
 *  from simple-icons (CC0); coloured with Adobe's brand red. */
export function AdobeAnalyticsLogo({ className }: { className?: string }) {
  return (
    <svg
      aria-hidden="true"
      className={className}
      viewBox="0 0 24 24"
      width="24"
      height="24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.966 22.624l-1.69-4.281H8.122l3.892-9.144 5.662 13.425zM8.884 1.376H0v21.248zm15.116 0h-8.884L24 22.624Z"
        fill="#FA0F00"
      />
    </svg>
  );
}
